import { actionTypes } from '../actions/metrics.action';
const initialState = {
    metric: {
        total_amount: 0,
        total_transaction: 0,
        gasto_transaction: 0,
        total_user: 0,
        gasto_medio: 0,
        total_cotas: 0
    },
}

const MetricsReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            metric: (payload === 'clear') ? {} : {
                ...state.metric,
                ...payload
            }
        }

    default:
        return state
    }
}

export default MetricsReducer